export function AnalyticsSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      {/* KPI cards skeleton */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="rounded-lg border border-border bg-wt-bg-secondary p-6">
            <div className="h-4 bg-wt-bg-tertiary rounded w-1/3 mb-4" />
            <div className="h-8 bg-wt-bg-tertiary rounded w-2/3 mb-2" />
            <div className="h-3 bg-wt-bg-tertiary rounded w-1/2" />
          </div>
        ))}
      </div>
      {/* Chart skeleton */}
      <div className="rounded-lg border border-border bg-wt-bg-secondary p-6">
        <div className="h-4 bg-wt-bg-tertiary rounded w-1/4 mb-6" />
        <div className="h-[300px] bg-wt-bg-tertiary rounded" />
      </div>
      {/* Bottom row skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[1, 2].map((i) => (
          <div key={i} className="rounded-lg border border-border bg-wt-bg-secondary p-6">
            <div className="h-4 bg-wt-bg-tertiary rounded w-1/3 mb-4" />
            <div className="h-6 bg-wt-bg-tertiary rounded w-1/2 mb-2" />
            <div className="h-3 bg-wt-bg-tertiary rounded w-2/3" />
          </div>
        ))}
      </div>
    </div>
  );
}
